import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NotificationSettingsService } from "src/app/services/notificationSettings.service";
import { IFormDialogData } from "src/app/shared/form/form.component";
import { DateFormatService } from "src/app/services/dateFormat.service";
import { ParameterService } from "src/app/services/parameter.service";
import { NotificationSettingsDialogComponent } from "../notification-settings-dialog/notification-settings-dialog.component";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";
import { ValueConversionService } from "src/app/services/value-conversion.service";
import { ControlService } from "src/app/services/control.service";

@Component({
  standalone: false,
  selector: 'app-clone-notification-settings-dialog',
  templateUrl: "./../../shared/form/form.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./../../shared/form/form.component.scss"],
})
export class CloneNotificationSettingsDialogComponent extends NotificationSettingsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<NotificationSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
    protected injector: Injector,
    protected notificationSettingsService: NotificationSettingsService,
    protected dateFormatService: DateFormatService,
    protected parameterService: ParameterService,
    protected organizationLevelService: OrganizationLevelService,
    protected valueConversionService: ValueConversionService,
    protected controlService: ControlService) {
    super(dialogRef, data, injector, notificationSettingsService, dateFormatService, parameterService, organizationLevelService, valueConversionService, controlService)
  }

  ngOnInit(): void {
    this.title = 'Clone Notification Settings';
    super.ngOnInit();
  }

  saveAction(model){
    return this.notificationSettingsService.clone(model);
  }
}
